import { render, staticRenderFns } from "./SettingsField.vue?vue&type=template&id=13f36860&scoped=true&"
import script from "./SettingsField.vue?vue&type=script&lang=js&"
export * from "./SettingsField.vue?vue&type=script&lang=js&"
import style0 from "./SettingsField.vue?vue&type=style&index=0&id=13f36860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f36860",
  null
  
)

export default component.exports